//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  ao: "अंगोला",
  ai: "अँग्विला",
  aq: "अंटार्क्टिका",
  ag: "अँटिग्वा आणि बर्बुडा",
  ad: "अँडोरा",
  az: "अझरबैजान",
  af: "अफगाणिस्तान",
  as: "अमेरिकन सामोआ",
  aw: "अरुबा",
  ar: "अर्जेंटिना",
  am: "अर्मेनिया",
  sv: "अल साल्वाडोर",
  dz: "अल्जीरिया",
  al: "अल्बानिया",
  ax: "अ‍ॅलँड बेटे",
  is: "आइसलँड",
  ie: "आयर्लंड",
  im: "आयल ऑफ मॅन",
  ci: "आयव्हरी कोस्ट",
  id: "इंडोनेशिया",
  ec: "इक्वाडोर",
  gq: "इक्वेटोरियल गिनी",
  eg: "इजिप्त",
  it: "इटली",
  et: "इथिओपिया",
  iq: "इराक",
  ir: "इराण",
  il: "इस्त्राइल",
  sz: "इस्वातिनी",
  uz: "उझबेकिस्तान",
  kp: "उत्तर कोरिया",
  mk: "उत्तर मॅसेडोनिया",
  mp: "उत्तरी मारियाना बेटे",
  uy: "उरुग्वे",
  er: "एरिट्रिया",
  ee: "एस्टोनिया",
  at: "ऑस्ट्रिया",
  au: "ऑस्ट्रेलिया",
  om: "ओमान",
  kh: "कंबोडिया",
  kz: "कझाकस्तान",
  qa: "कतार",
  cd: "काँगो - किंशासा",
  cg: "काँगो - ब्राझाविले",
  kg: "किरगिझस्तान",
  ki: "किरीबाटी",
  ck: "कुक बेटे",
  kw: "कुवेत",
  ca: "कॅनडा",
  cm: "कॅमेरून",
  bq: "कॅरिबियन नेदरलँड्स",
  cf: "केंद्रीय अफ्रिकी प्रजासत्ताक",
  ke: "केनिया",
  cv: "केप व्हर्डे",
  ky: "केमन बेटे",
  cc: "कोकोस (कीलिंग) बेटे",
  km: "कोमोरोज",
  co: "कोलम्बिया",
  cr: "कोस्टा रिका",
  cw: "क्युरासाओ",
  cu: "क्यूबा",
  hr: "क्रोएशिया",
  cx: "ख्रिसमस बेट",
  gy: "गयाना",
  gm: "गाम्बिया",
  gn: "गिनी",
  gw: "गिनी-बिसाउ",
  gu: "गुआम",
  ga: "गॅबॉन",
  gl: "ग्रीनलंड",
  gr: "ग्रीस",
  gd: "ग्रेनेडा",
  gt: "ग्वाटेमाला",
  gp: "ग्वाडेलोउपे",
  gg: "ग्वेर्नसे",
  gh: "घाना",
  td: "चाड",
  cl: "चिली",
  cn: "चीन",
  jp: "जपान",
  jm: "जमैका",
  de: "जर्मनी",
  je: "जर्सी",
  dj: "जिबौटी",
  gi: "जिब्राल्टर",
  ge: "जॉर्जिया",
  jo: "जॉर्डन",
  zm: "झाम्बिया",
  zw: "झिम्बाब्वे",
  cz: "झेकिया",
  tc: "टर्क्स आणि कैकोस बेटे",
  tz: "टांझानिया",
  tv: "टुवालु",
  to: "टोंगा",
  tg: "टोगो",
  tn: "ट्यूनिशिया",
  dk: "डेन्मार्क",
  do: "डोमिनिकन प्रजासत्ताक",
  dm: "डोमिनिका",
  tj: "ताजिकिस्तान",
  tl: "तिमोर-लेस्ते",
  tm: "तुर्कमेनिस्तान",
  tr: "तुर्की",
  tw: "तैवान",
  tk: "तोकेलाउ",
  tt: "त्रिनिदाद आणि टोबॅगो",
  th: "थायलंड",
  za: "दक्षिण आफ्रिका",
  kr: "दक्षिण कोरिया",
  gs: "दक्षिण जॉर्जिया आणि दक्षिण सँडविच बेटे",
  ss: "दक्षिण सुदान",
  ne: "नाइजर",
  nr: "नाउरू",
  na: "नामिबिया",
  ng: "नायजेरिया",
  ni: "निकाराग्वा",
  nu: "नीयू",
  nl: "नेदरलँड",
  np: "नेपाळ",
  nf: "नॉरफॉक बेट",
  no: "नॉर्वे",
  nc: "न्यू कॅलेडोनिया",
  nz: "न्यूझीलंड",
  pa: "पनामा",
  py: "पराग्वे",
  pw: "पलाऊ",
  eh: "पश्चिम सहारा",
  pk: "पाकिस्तान",
  pg: "पापुआ न्यू गिनी",
  pn: "पिटकैर्न बेटे",
  ps: "पॅलेस्टिनियन प्रदेश",
  pe: "पेरू",
  pt: "पोर्तुगाल",
  pl: "पोलंड",
  pr: "प्युएर्तो रिको",
  fj: "फिजी",
  fi: "फिनलंड",
  ph: "फिलिपिन्स",
  fo: "फेरो बेटे",
  fk: "फॉकलंड बेटे",
  fr: "फ्रान्स",
  gf: "फ्रेंच गयाना",
  tf: "फ्रेंच दाक्षिणात्य प्रदेश",
  pf: "फ्रेंच पॉलिनेशिया",
  bm: "बर्मुडा",
  bg: "बल्गेरिया",
  bs: "बहामाज",
  bh: "बहारीन",
  bd: "बांगलादेश",
  bb: "बार्बाडोस",
  bi: "बुरुंडी",
  bf: "बुर्किना फासो",
  bj: "बेनिन",
  by: "बेलारूस",
  bz: "बेलिझे",
  be: "बेल्जियम",
  bv: "बोउवेट बेट",
  bw: "बोट्सवाना",
  bo: "बोलिव्हिया",
  ba: "बोस्निया अणि हर्जेगोविना",
  br: "ब्राझिल",
  vg: "ब्रिटिश व्हर्जिन बेटे",
  io: "ब्रिटिश हिंदी महासागर क्षेत्र",
  bn: "ब्रुनेई",
  in: "भारत",
  bt: "भूतान",
  mn: "मंगोलिया",
  mo: "मकाओ एसएआर चीन",
  mw: "मलावी",
  my: "मलेशिया",
  mg: "मादागास्कर",
  fm: "मायक्रोनेशिया",
  yt: "मायोट्टे",
  mq: "मार्टिनिक",
  mh: "मार्शल बेटे",
  mv: "मालदीव",
  ml: "माली",
  mt: "माल्टा",
  mx: "मेक्सिको",
  ms: "मॉन्ट्सेराट",
  mr: "मॉरिटानिया",
  mu: "मॉरिशस",
  me: "मोंटेनेग्रो",
  mz: "मोझाम्बिक",
  mc: "मोनॅको",
  ma: "मोरोक्को",
  md: "मोल्डोव्हा",
  mm: "म्यानमार (बर्मा)",
  ua: "युक्रेन",
  ug: "युगांडा",
  gb: "युनायटेड किंगडम",
  us: "युनायटेड स्टेट्स",
  um: "यू.एस. आउटलाइंग बेटे",
  vi: "यू.एस. व्हर्जिन बेटे",
  ye: "येमेन",
  rw: "रवांडा",
  ru: "रशिया",
  re: "रियुनियन",
  ro: "रोमानिया",
  lu: "लक्झेंबर्ग",
  la: "लाओस",
  lv: "लात्विया",
  lr: "लायबेरिया",
  li: "लिक्टेनस्टाइन",
  lt: "लिथुआनिया",
  ly: "लिबिया",
  lb: "लेबनॉन",
  ls: "लेसोथो",
  vu: "वानुआतु",
  wf: "वालिस आणि फ्यूचूना",
  vn: "व्हिएतनाम",
  va: "व्हॅटिकन सिटी",
  ve: "व्हेनेझुएला",
  lk: "श्रीलंका",
  ae: "संयुक्त अरब अमीरात",
  rs: "सर्बिया",
  st: "साओ टोम आणि प्रिंसिपे",
  ws: "सामोआ",
  cy: "सायप्रस",
  sg: "सिंगापूर",
  sx: "सिंट मार्टेन",
  sl: "सिएरा लिओन",
  sy: "सीरिया",
  sd: "सुदान",
  sr: "सुरिनाम",
  sm: "सॅन मरीनो",
  kn: "सेंट किट्स आणि नेव्हिस",
  pm: "सेंट पियरे आणि मिक्वेलोन",
  bl: "सेंट बार्थेलेमी",
  mf: "सेंट मार्टिन",
  lc: "सेंट ल्यूसिया",
  vc: "सेंट व्हिन्सेंट आणि ग्रेनडाइन्स",
  sh: "सेंट हेलेना",
  sn: "सेनेगल",
  sc: "सेशेल्स",
  so: "सोमालिया",
  sb: "सोलोमन बेटे",
  sa: "सौदी अरब",
  es: "स्पेन",
  sk: "स्लोव्हाकिया",
  si: "स्लोव्हेनिया",
  sj: "स्वालबर्ड आणि जान मायेन",
  ch: "स्वित्झर्लंड",
  se: "स्वीडन",
  hu: "हंगेरी",
  hm: "हर्ड आणि मॅक्डोनाल्ड बेटे",
  hk: "हाँगकाँग एसएआर चीन",
  ht: "हैती",
  hn: "होंडुरास",
};
